// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-input--selection-controls{margin-top:0!important}.checkbox--background-white{background:#fff;border-radius:var(--v-border-radius)}.theme--light.v-label{color:rgba(0,0,0,.87)}.theme--light.v-label--is-disabled{color:rgba(0,0,0,.38)}.theme--light.v-card .v-card__subtitle,.theme--light.v-card>.v-card__text{color:rgba(0,0,0,.87)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
